import React from 'react';
import { useLocation } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';

const Login = () => {
  const location = useLocation();
  const message = location.state?.message;

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-50 via-cream-100 to-brown-50 flex items-center justify-center p-4 sm:p-6 md:p-8">
      <div className="w-full max-w-md">
        {/* Show message if redirected from signup */}
        {message && (
          <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-green-50/80 backdrop-blur-sm border border-green-200/50 rounded-lg sm:rounded-xl animate-slide-up">
            <p className="text-xs sm:text-sm text-green-800 text-center">{message}</p>
          </div>
        )}
        
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;